<template>
  <Card class="p-mb-3">
    <template #title>
      <div class="p-grid p-m-0">
        <span style="padding-right: 5px">Vender por valor geral</span>
        <div class="p-col-12 p-md-3">
          <BovineTypeSummary
            style="padding: 3px 0"
            :bovines="bovines.map((bovine) => bovine.bovine)"
          ></BovineTypeSummary>
        </div>
      </div>
    </template>
    <template #content>
      <AppForm>
        <div class="p-grid p-fluid p-formgrid">
          <div class="p-field p-col-12 p-md-6 p-lg-2">
            <AppFormItem label="Peso total">
              <InputNumber
                v-model="totalWeight"
                :disabled="true"
                :minFractionDigits="2"
                mode="decimal"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6 p-lg-2">
            <AppFormItem label="Média Kg/bovino">
              <InputNumber
                :value="$roundNumber(totalWeight / bovines.length)"
                :disabled="true"
                :minFractionDigits="2"
                mode="decimal"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6 p-lg-2">
            <AppFormItem label="Tipo de cálculo">
              <AppAutoComplete
                v-model="generalValue.typeId"
                :options="generalCalculationOptions"
              ></AppAutoComplete>
            </AppFormItem>
          </div>
          <div
            class="p-field p-col-12 p-md-6 p-lg-2"
            v-if="generalValue.typeId === 2"
          >
            <AppFormItem label="Peso da Arroba (Kg)">
              <InputNumber
                v-model="generalValue.arrobaWeight"
                :minFractionDigits="2"
                mode="decimal"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6 p-lg-2">
            <AppFormItem label="Valor">
              <InputNumber
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                v-model="generalValue.value"
                :minFractionDigits="2"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6 p-lg-2">
            <AppFormItem label="Valor Total">
              <InputNumber
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                v-model="totalGeneralValue"
                :disabled="true"
                :minFractionDigits="2"
              />
            </AppFormItem>
          </div>
          <div class="p-col-12">
            <div class="p-grid p-jc-end p-mt-2">
              <div style="padding-right: 8px">
                <Button label="Aplicar" @click="applyGeneralValue()" />
              </div>
            </div>
          </div>
        </div>
      </AppForm>
    </template>
  </Card>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapGetters } from 'vuex';
import BovineTypeSummary from '../../components/BovineTypeSummary.vue';

export default {
  components: {
    BovineTypeSummary,
  },
  data() {
    return {
      generalCalculationOptions: [
        { id: 1, name: 'Cálculo por kg' },
        { id: 2, name: 'Cálculo por arroba' },
        { id: 3, name: 'Valor por bovino' },
        { id: 4, name: 'Valor total da venda' },
      ],
    };
  },
  computed: {
    ...mapFields('sale', ['formData.bovines', 'formData.generalValue']),
    ...mapGetters('sale', ['totalWeight', 'totalGeneralValue']),
  },
  methods: {
    ...mapActions('sale', ['applyGeneralValue']),
  },
};
</script>

<style>
</style>
